import React from 'react';
import { Link, useLocation } from 'react-router-dom';

function SideMenu({ openSlider, setOpenSlider }) {
    const location = useLocation();
    const path = location.pathname;

    const navItems = [
        { path: '/dashboard', icon: 'fa-dashcube', label: 'Dashboard' },
        { path: '/dashboard/products', icon: 'fa-box-open', label: 'Products' },
        { path: '/dashboard/orders', icon: 'fa-clipboard', label: 'Orders' },
        { path: '/dashboard/review', icon: 'fa-star-half-alt', label: 'Reviews' },
        { path: '/dashboard/income', icon: 'fa-wallet', label: 'Income' },
        { path: '/dashboard/coupon', icon: 'fa-percentage', label: 'Coupons' },
        { path: '/dashboard/categories', icon: 'fa-list-alt', label: 'Categories' },
        { path: '/dashboard/help', icon: 'fa-question-circle', label: 'Help' },
        { path: '/dashboard/users', icon: 'fa-users', label: 'Users' }
    ];

    return (
        <div className='vh-100 d-flex flex-column'>
            <div className={`nav-header d-flex ${openSlider ? 'justify-content-between' : 'justify-content-center'} align-items-center px-2 py-1 py-md-3`}>
                <h5 className="h5 py-2 py-md-0 m-0 text-center"><i className="fa fa-connectdevelop"></i> {openSlider ? 'Dashboard' : ''}</h5>
                {openSlider && (
                    <div className="close-btn d-md-none">
                        <button className='px-3 py-2 rounded bg-dark text-light border-0' onClick={() => { setOpenSlider(false) }}><i className="fa fa-close"></i></button>
                    </div>
                )}
            </div>
            <div className="nav-body small d-flex flex-column justify-content-between flex-grow-1 mt-4">
                <div className="nav-items">
                    {navItems.map((item) => {
                        const isActive = path === item.path || (item.path === '/admin' && path === '/admin/');
                        return (
                            <div className="nav-item my-2 mx-1" key={item.path}>
                                <Link to={item.path} className='text-decoration-none hover-side-nav-link'>
                                    <div className={`nav-link py-2 rounded d-flex align-items-center ${openSlider ? 'px-3' : 'justify-content-center px-0'} ${isActive ? 'bg-white text-black fw-bold active-drop-shadow' : 'bg-transparent text-white fw-lighter'}`}>
                                        <i className={`fas fa ${item.icon} text-center`} style={{ width: '20px', fontSize: '1.1rem' }}></i>
                                        {openSlider && <span className="item ms-2">{item.label}</span>}
                                    </div>
                                </Link>
                            </div>
                        );
                    })}
                </div>
                <div className="nav-items mb-3">
                    <div className="nav-item my-2 mx-1">
                        <Link to={'/profile'} className='text-decoration-none hover-side-nav-link'>
                            <div className={`nav-link py-2 rounded d-flex align-items-center ${openSlider ? 'px-3' : 'justify-content-center px-0'} text-white`}>
                                <i className="fas fa-user-circle text-center" style={{ width: '20px', fontSize: '1.1rem' }}></i>
                                {openSlider && <span className="item ms-2">User Profile</span>}
                            </div>
                        </Link>
                    </div>
                    <div className="nav-item my-2 mx-1">
                        <Link to={'/logout'} className='text-decoration-none hover-side-nav-link'>
                            <div className={`nav-link py-2 rounded d-flex align-items-center ${openSlider ? 'px-3' : 'justify-content-center px-0'} text-white`}>
                                <i className="fas fa-sign-out-alt text-center" style={{ width: '20px', fontSize: '1.1rem' }}></i>
                                {openSlider && <span className="item ms-2">Logout</span>}
                            </div>
                        </Link>
                    </div>
                </div>
            </div >
        </div >
    )
}

export default SideMenu;